const typeDefs = ``

const resolvers = {}

const mock = { resolvers, typeDefs }

export default mock
